import { useState } from 'react'
import { formatDate, safeParseDate } from 'utils/date'
import { RATING_LABELS } from 'utils/constants'
import Content from 'components/barbeibot/Content'
import { H2, Paragraph } from 'components/typography'
import Tooltip from 'components/tooltips/Tooltip'
import Modal from './Modal'
import GalleryModal from './GalleryModal'
import styles from './BarbeibotImageReview.module.css'

function BarbeibotImageReview({ image = {}, onClose }) {
  const [showZoom, setShowZoom] = useState(false)

  const photo = image.location

  return (
    <Modal onCancel={onClose} showActions={false} showCloseIcon>
      <div className={styles.modal}>
        <H2>Barbei-bot review 🧐</H2>
        {image.date && (
          <Paragraph className={styles.selectedDate} type='body2Bold'>
            {formatDate({
              date: safeParseDate(image.date),
              stringFormat: 'EEEE, d MMMM Y - HH:mm'
            })}
          </Paragraph>
        )}
        <div className={styles.photoArea}>
          <div className={styles.ratingButtonContainer}>
            <Tooltip
              classNames={{ title: styles.tooltipTitle }}
              placement='top'
              title={
                <span>
                  {RATING_LABELS[image.rating] || 'El alumno no ha valorado'}
                </span>
              }
            >
              <div className={styles.emoji}>🌟</div>
            </Tooltip>
          </div>
          {photo ? (
            <div className={styles.imgContainer}>
              <img
                className={styles.img}
                src={photo}
                onClick={() => setShowZoom(true)}
              />
            </div>
          ) : (
            <div className={styles.emptyImg}>
              <Paragraph type='body2'>Sin imagen</Paragraph>
            </div>
          )}
        </div>
        <Paragraph className={styles.paragraph} type='body2Bold'>
          Análisis
        </Paragraph>
        <Content className={styles.markdown} content={image.analysis} />
        {showZoom && (
          <GalleryModal
            initialIndex={0}
            photos={[{ location: photo }]}
            onCancel={() => setShowZoom(false)}
          />
        )}
      </div>
    </Modal>
  )
}

export default BarbeibotImageReview
